/**
 * @generated SignedSource<<9109a87049eda27029b52970e24c7182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PinningUnpinMutationInput = {
  clientMutationId?: string | null;
  id: string;
};
export type MarkAsOption_unpinNodeMutation$variables = {
  input: PinningUnpinMutationInput;
};
export type MarkAsOption_unpinNodeMutation$data = {
  readonly unpin: {
    readonly nodeUnpinned: {
      readonly __typename: string;
      readonly id: string;
      readonly pins?: ReadonlyArray<{
        readonly context: string;
        readonly id: string;
        readonly label: string | null;
      }> | null;
    };
  } | null;
};
export type MarkAsOption_unpinNodeMutation = {
  response: MarkAsOption_unpinNodeMutation$data;
  variables: MarkAsOption_unpinNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PinningUnpinMutationPayload",
    "kind": "LinkedField",
    "name": "unpin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeUnpinned",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Pin",
                "kind": "LinkedField",
                "name": "pins",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "HasPinsInterface",
            "abstractKey": "__isHasPinsInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkAsOption_unpinNodeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkAsOption_unpinNodeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "15cd19b1b4ab384e624ffb1b298adbd0",
    "id": null,
    "metadata": {},
    "name": "MarkAsOption_unpinNodeMutation",
    "operationKind": "mutation",
    "text": "mutation MarkAsOption_unpinNodeMutation(\n  $input: PinningUnpinMutationInput!\n) {\n  unpin(input: $input) {\n    nodeUnpinned {\n      __typename\n      id\n      ... on HasPinsInterface {\n        __isHasPinsInterface: __typename\n        pins {\n          context\n          id\n          label\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9da817898143b174dcd5cbdf10d2d716";

export default node;
